
    import PageHeader from '../components/Layout/PageHeader.vue';
    import CheckMark from '../components/Animations/Checkmark.vue';

    export default {
        data() {
            return {
                loading: true,
                educations: [],
                scholarships_active: false,

                full_name: null,
                email: null,
                birth_date: null,
                birth_place: null,
                telephone: null,

                qualification: null,
                area_of_study: null,

                current_work_position: null,
                work_experience: null,

                reason_of_interest: null,
                expected_qualities: null,

                marginalized_group: null,

                expected_skills: null,
                future_plans: null,

                availability: null,
                participation: null,

                motivation_description: null,
                reason_description: null,
                
                motivational_letter: null,
                attachment: null,
                selected_education: null,

                error_messages: [],
                submit_complete: false,
                sending_data: false,
            };
        },
        created() {
            this.fetchCaseStudies();
        },
        mounted() {
            // console.log('Component mounted.')
        },
        methods: {
            async fetchCaseStudies() {
                const result = await this.$axios.get("/scholarship/educations");
                // .then(response => {
                //     this.case_studies = response.data.data;
                //     this.loading = false;
                // })
                this.educations = result.data.data;
                this.loading = false;
            },

            uploadMotivationalLetter(event){
                const file = event.target.files[0];
                if(file.size > 5242880){
                    return alert('The file size can not exceed 5MB.');
                }
                this.attachment = file;
            },


            submitData(){
                this.error_messages = [];

                var formData = new FormData();
                if(this.attachment){
                    formData.append('attachment', this.attachment);
                }

                const form_data = {
                    full_name:                  this.full_name,
                    email:                      this.email,
                    birth_date:                 this.birth_date,
                    birth_place:                this.birth_place,
                    telephone:                  this.telephone,
                    qualification:              this.qualification,
                    area_of_study:              this.area_of_study,
                    current_work_position:      this.current_work_position,
                    work_experience:            this.work_experience,
                    reason_of_interest:         this.reason_of_interest,
                    expected_qualities:         this.expected_qualities,
                    marginalized_group:         this.marginalized_group,
                    expected_skills:            this.expected_skills,
                    future_plans:               this.future_plans,
                    availability:               this.availability,
                    participation:              this.participation,
                    motivation_description:     this.motivation_description,
                    reason_description:         this.reason_description,
                    motivational_letter:        this.motivational_letter,
                    selected_education:         this.selected_education,
                }

                formData.append('document', JSON.stringify(form_data));

                this.sending_data = true;

                this.$axios.post("/scholarship/submit", formData, {headers: {'Content-Type': 'multipart/form-data'}})
                    .then(response => {
                    if (response.status === 200) {
                        //console.log(response);
                        window.scrollTo(0, 0);
                        this.submit_complete = true;
                        this.sending_data = false;
                    }
                })
                    .catch(error => {
                    if (error.response) {
                        window.scrollTo(0, 0);
                        if (error.response.status === 422) {
                            this.main_error_message = "Provjerite jesu li sva polja ispravno popunjena.";
                        }
                        if (error.response.status === 409) {
                            this.main_error_message = "Prijava sa ovom email adresom je već izvršena za ovu edukaciju.";
                        }
                        if (error.response.data) {
                            this.error_messages = error.response.data.errors;
                        }
                        this.sending_data = false;
                    }
                });
            }
        },
        components: { PageHeader, CheckMark }
    }
